import styled from 'styled-components'

export const CampoMensagem = styled.div`
    padding: 20px;
`